export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      icon: 'ri-stack-line',
      title: 'Choose Your Tier',
      description: 'Select the intelligence level that matches your stage and goals.'
    },
    {
      number: '02',
      icon: 'ri-upload-cloud-line',
      title: 'Submit Your App',
      description: 'Provide your app details and any relevant context for evaluation.'
    },
    {
      number: '03',
      icon: 'ri-cpu-line',
      title: 'Intelligence Systems Run',
      description: 'Our structured AI frameworks analyze your app across multiple dimensions.'
    },
    {
      number: '04',
      icon: 'ri-file-text-line',
      title: 'Get Your Full Report',
      description: 'Receive a polished PDF with scores, insights, and strategic recommendations.'
    },
    {
      number: '05',
      icon: 'ri-arrow-right-up-line',
      title: 'Your Next Step Unlocked',
      description: 'Clear direction on what to do next — upgrade, refine, or launch.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            How It Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Five clear steps from uncertainty to clarity
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-6 h-full border-2 border-gray-200 hover:border-teal-400 transition-all hover:shadow-lg">
                <div className="text-5xl font-bold text-teal-600/20 mb-4">
                  {step.number}
                </div>
                
                <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-teal-600 to-blue-600 rounded-xl mb-4">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
                
                <h3 className="text-lg font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 z-10">
                  <i className="ri-arrow-right-line text-2xl text-teal-400"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
